module.exports = __webpack_public_path__ + "img/motor_no70.aea44a13.jpg";